var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job--edit--languages" },
    [
      _c(
        "b-form-checkbox",
        {
          staticClass: "mb-3",
          on: { input: _vm.emitChangeEvent },
          model: {
            value: _vm.none,
            callback: function($$v) {
              _vm.none = $$v
            },
            expression: "none"
          }
        },
        [_vm._v("\n\t\tEs sind keine Sprachkenntnisse nötig\n\t")]
      ),
      _vm._v(" "),
      !_vm.none
        ? [
            _c(
              "div",
              { staticClass: "job--edit--languages-items" },
              _vm._l(_vm.items, function(item) {
                return _c("Item", {
                  key: item.id,
                  attrs: { item: item, meta: _vm.meta },
                  on: {
                    remove: function($event) {
                      return _vm.remove(item)
                    },
                    input: function($event) {
                      return _vm.itemChanged(item, $event)
                    }
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            !_vm.hasItems || _vm.itemsValid
              ? _c(
                  "div",
                  { staticClass: "job--edit--languages-autocomplete" },
                  [
                    _vm.items.length > 0
                      ? _c("h3", [_vm._v("Weitere Sprache hinzufügen")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("VueSimpleSuggest", {
                      ref: "autocomplete",
                      attrs: {
                        placeholder: _vm.keywordPlaceholder,
                        list: _vm.filteredLanguages,
                        debounce: 250,
                        "min-length": 3,
                        "display-attribute": "label",
                        styles: _vm.autoCompleteStyle,
                        "max-suggestions": 0,
                        "prevent-submit": false
                      },
                      on: { "suggestion-click": _vm.languageClicked },
                      model: {
                        value: _vm.keyword,
                        callback: function($$v) {
                          _vm.keyword = $$v
                        },
                        expression: "keyword"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }